export default __webpack_public_path__ + "static/media/logout.a490b7a2.svg";